export const MAINTENANCE_MODE_EVENT = 'app:maintenance-mode';

interface MaintenanceModeEventDetail {
  enabled: boolean;
}

export const setMaintenanceMode = (enabled: boolean): void => {
  window.dispatchEvent(
    new CustomEvent<MaintenanceModeEventDetail>(MAINTENANCE_MODE_EVENT, {
      detail: { enabled },
    })
  );
};
